export const CUSTOMER_ACTIONS = {
  CREATE: 'CUSTOMERS_CREATE',
  VIEW: 'CUSTOMERS_VIEW',
  LIST: 'CUSTOMERS_LIST',
  UPDATE: 'CUSTOMERS_UPDATE',
  DELETE: 'CUSTOMERS_DELETE',
  SEND_PUSH: 'CUSTOMERS_SEND_PUSH',
  UPLOAD_AVATAR: 'CUSTOMERS_UPLOAD_AVATAR',
  DELETE_AVATAR: 'CUSTOMERS_DELETE_AVATAR'
};